<script lang="ts" setup>
import { ref, useAuth } from "#imports";
import MPCreatorOnboarding from "./MPCreatorOnboarding.vue";
import MPLogin from "./MPLogin.vue";
import MPMagicLink from "./MPMagicLink.vue";
import MPSignUp from "./MPSignUp.vue";

export type AuthSteps = "login" | "signup" | "magiclink";

const props = withDefaults(
  defineProps<{
    login?: boolean;
    showLogo?: boolean;
    title?: string;
    summary?: string;
    startOn?: AuthSteps;
    showFooter?: boolean;
    userType?: string;
  }>(),
  {
    login: false,
    showLogo: false,
    title: "Login or Join",
    summary: "Access Bookmarks, Members only content, and more",
    startOn: "login",
    showFooter: true,
    userType: "user",
  },
);

// auth step
const authStep = ref<AuthSteps>(props.startOn);

const toggleAuthStep = (step: AuthSteps) => {
  authStep.value = step;
};

const authStore = useAuth();
const onboarding = ref(authStore.isLoggedIn && props.userType === "creator");
</script>

<template>
  <div v-if="!onboarding" class="authentication-form">
    <div v-if="authStep === 'login'">
      <MPLogin
        @toggleAuthStep="toggleAuthStep($event)"
        @startOnboarding="onboarding = true"
      />
    </div>
    <div v-if="authStep === 'signup'">
      <MPSignUp
        :userType="props.userType"
        @toggleAuthStep="toggleAuthStep($event)"
        @startOnboarding="onboarding = true"
      />
    </div>
    <div v-if="authStep === 'magiclink'">
      <MPMagicLink @toggleAuthStep="toggleAuthStep($event)" />
    </div>
  </div>
  <div v-else class="onboarding-wrapper">
    <div v-if="props.userType === 'creator'">
      <MPCreatorOnboarding />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";

div {
  height: 100%;
}

.authentication-form {
  max-width: 100%;
  min-width: 24rem;
  margin: 0 auto;
  display: grid;
  gap: 1rem;
  text-align: center;

  @mixin screen sm {
    max-width: 22rem;
  }
}

.onboarding-wrapper {
  max-width: 30rem;
  margin: 0 auto;
  display: grid;
  gap: 1rem;
  text-align: center;
}

.login {
  display: grid;
  gap: 1rem;
}

.auth-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--color-slate-800);
  margin: 0.5rem 0 0 0;
}

.auth-summary {
  color: var(--color-slate-400);
  margin-bottom: 0.75rem;
}
</style>
